import { render, staticRenderFns } from "./SurveyText.vue?vue&type=template&id=f2a61844&scoped=true&"
import script from "./SurveyText.vue?vue&type=script&lang=js&"
export * from "./SurveyText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a61844",
  null
  
)

export default component.exports